module.exports = {
  basePath: "https://backend.ursmartspoc.com",
  headers: {
    Authorization: "Basic YWRtaW5Ac3lzLmNvbTphZG1pbjEyMw==",
    "Content-Type": "application/json",
  },
};
